<template>
  <b-modal id="bv-modal-advertising" size="lg">
    <template #modal-header>
      <h4>{{ data.id ? $t("edit_advertising") : $t("create_advertising") }}</h4>
      <b-button
        size="sm"
        variant="outline-light"
        class="ml-auto"
        @click="$bvModal.hide('bv-modal-advertising')"
      >
        <i class="fas fa-times"></i>
      </b-button>
    </template>
    <b-form class="auth-register-form mt-2">
      <b-row>
        <b-col :xs="12" :sm="12" :md="12" :lg="3" class="text-center">
          <div
            style="cursor: pointer"
            id="pick-image"
            class="table-text mt-md-4"
          >
            <b-avatar rounded="sm" :src="preview" size="150px"> </b-avatar
            ><br />
            <small v-if="statusImage" class="text-danger mt-3">{{
              $t("image_required")
            }}</small>
            <p>
              <small>{{ $t("selected-image") }}</small>
            </p>
            <br />
          </div>
          <avatar-cropper
            :upload-handler="selectedFile"
            @changed="setFileName"
            trigger="#pick-image"
            :labels="{
              submit: $t('accept'),
              cancel: $t('cancel'),
            }"
            :cropper-options="{
              aspectRatio: 1,
              autoCropArea: 1,
              viewMode: 1,
              movable: false,
              zoomable: false,
            }"
          />
        </b-col>
        <b-col :xs="12" :sm="12" :md="12" :lg="9">
          <b-row class="table-text">
            <b-col :md="6">
              <b-form-group :label="$t('form.name')">
                <b-form-input
                  v-model="data.name"
                  type="text"
                  :placeholder="$t('form.name-placeholder')"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :data-vv-as="$t('form.name')"
                  name="name"
                  autocomplete="off"
                ></b-form-input>
                <span class="text-danger text-sm" v-show="errors.has('name')"
                  ><small>{{ errors.first("name") }}</small></span
                >
              </b-form-group>
            </b-col>
            <b-col :md="6">
              <b-form-group :label="$t('form.amount')">
                <b-form-input
                  v-model="data.amount"
                  type="number"
                  :placeholder="$t('form.amount-placeholder')"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :data-vv-as="$t('form.amount')"
                  name="amount"
                  autocomplete="off"
                ></b-form-input>
                <span class="text-danger text-sm" v-show="errors.has('amount')"
                  ><small>{{ errors.first("amount") }}</small></span
                >
              </b-form-group>
            </b-col>
            <b-col :md="12">
              <b-form-group :label="$t('form.price')">
                <b-input-group>
                  <b-form-input
                    v-model="data.price"
                    type="number"
                    :placeholder="$t('form.price-placeholder')"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    :data-vv-as="$t('price')"
                    name="price"
                    autocomplete="off"
                  ></b-form-input>
                  <template #append>
                    <v-select
                      v-model="data.currency_id"
                      :placeholder="$t('coin')"
                      :disabled="true"
                      style="width: 130px; border-radius: 0px 5px 5px 0px"
                      class="
                        form-control-alternative
                        border
                        bg-white
                        p-1
                        table-text
                      "
                      :options="[]"
                      label="symbol"
                      data-vv-validate-on="blur"
                      v-validate="'required'"
                      :data-vv-as="$t('currency')"
                      name="currency_id"
                      autocomplete="off"
                    >
                      <template #no-options="{}"> {{ $t("fail") }}, </template>
                    </v-select>
                  </template>
                </b-input-group>
                <p class="text-danger text-sm" v-show="errors.has('price')">
                  <small>{{ errors.first("price") }}</small>
                </p>
                <p
                  class="text-danger text-sm"
                  v-show="errors.has('currency_id')"
                >
                  <small>{{ errors.first("currency_id") }}</small>
                </p>
              </b-form-group>
            </b-col>
            <b-col :md="6">
              <b-form-group :label="$t('duration')">
                <v-select
                  v-model="data.duration"
                  :placeholder="$t('duration')"
                  class="
                    text-dark
                    form-control-alternative
                    border
                    rounded
                    bg-white
                    p-1
                    table-text
                  "
                  :options="daisOptions"
                  label="symbol"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :data-vv-as="$t('duration')"
                  name="duration"
                  autocomplete="off"
                >
                  <template #no-options="{}"> {{ $t("fail") }}, </template>
                </v-select>
                <p class="text-danger text-sm" v-show="errors.has('duration')">
                  <small>{{ errors.first("duration") }}</small>
                </p>
              </b-form-group>
            </b-col>
            <b-col :md="6">
              <b-form-group :label="$t('max-ads')">
                <v-select
                  v-model="data.max_ads_creation"
                  :placeholder="$t('max-ads')"
                  class="
                    text-dark
                    rounded
                    form-control-alternative
                    border
                    bg-white
                    p-1
                    table-text
                  "
                  :options="adsOptions"
                  label="symbol"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :data-vv-as="$t('max-ads')"
                  name="max-ads"
                  autocomplete="off"
                >
                  <template #no-options="{}"> {{ $t("fail") }}, </template>
                </v-select>
                <p class="text-danger text-sm" v-show="errors.has('max-ads')">
                  <small>{{ errors.first("max-ads") }}</small>
                </p>
              </b-form-group>
            </b-col>
            <b-col :md="12">
              <b-form-group :label="$t('form.description')">
                <b-form-textarea
                  id="textarea-state"
                  class="bg-transparent"
                  rows="3"
                  v-model="data.description"
                  type="text"
                  :placeholder="$t('form.description-placeholder')"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :data-vv-as="$t('description')"
                  name="description"
                  autocomplete="off"
                  :state="!errors.has('description') ? null : false"
                ></b-form-textarea>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('description')"
                  ><small>{{ errors.first("description") }}</small></span
                >
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>

    <template #modal-footer>
      <b-button size="sm" variant="primary" @click="onSubmit()">
        {{ $t("save") }}
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        @click="$bvModal.hide('bv-modal-advertising')"
      >
        {{ $t("close") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";
import helpers from "@/services/helpers";
import { mapActions, mapGetters } from "vuex";
import { myRendeImage } from "@/directives/render-Image";
export default {
  mixins: [myRendeImage],
  components: {
    AvatarCropper,
  },
  mounted() {
    this.getCurrency();
  },
  watch: {
    preview() {
      if (this.data.image) {
        this.statusImage = !Boolean(this.data.image);
      }
    },
  },
  data() {
    return {
      data: {
        id: null,
        name: "",
        description: "",
        image: null,
        amount: null,
        price: null,
        // whp_price: null,
        currency_id: { id: 2, name: "Match Point", iso: "MP", symbol: "MP" },
        duration: 0,
        max_ads_creation: null,
      },
      statusImage: false,
      preview: null,
      fileSelected: null,
    };
  },
  methods: {
    ...mapActions({
      createOrUpdate: "advertising/createOrUpdate",
      getCurrency: "config/getCurrency",
    }),
    showModal(item) {
      this.formReset();
      this.preview = require("@/assets/img/brand/no-image.jpg");
      if (item) {
        this.data = {
          id: item.id,
          name: item.name,
          description: item.description,
          amount: item.amount,
          price: item.price,
          // whp_price: item.whp_price,
          currency_id: item.currency,
          duration: item.duration,
          max_ads_creation: item.max_ads_creation,
        };
        this.preview = item.image
          ? this.imageData(item.image)
          : require("@/assets/img/brand/no-image.jpg");
      }
      this.fileSelected = null;

      this.$bvModal.show("bv-modal-advertising");
    },
    setFileName(file) {
      this.fileSelected = file;
      this.data.image = file;
    },
    selectedFile(cropper) {
      const dataUrl = cropper
        .getCroppedCanvas()
        .toDataURL(this.fileSelected.type);
      const file = helpers.dataURLtoFile(dataUrl, this.fileSelected.name);
      this.preview = dataUrl;
      this.data.image = file;
    },
    formReset() {
      this.data = {
        id: null,
        name: "",
        description: "",
        image: null,
        amount: null,
        price: null,
        // whp_price: null,
        currency_id: { id: 2, name: "Match Point", iso: "MP", symbol: "MP" },
        duration: 0,
        max_ads_creation: null,
      };
      this.statusImage = false;
    },
    async onSubmit() {
      // if (this.preview) {
      //   this.statusImage = !Boolean(this.data.image);
      //   return;
      // }
      const validation = await this.$validator.validateAll();

      if (validation) {
        this.statusImage = !Boolean(this.data.image);
        try {
          const res = await this.createOrUpdate(this.data);
          if (res.status === 200) {
            this.$toast.success(res.data.message, {
              position: "top-right",
            });
          }
          this.$bvModal.hide("bv-modal-advertising");
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      // currency: "config/currency",
    }),
    daisOptions() {
      const dais = [];
      for (let i = 0; i < 31; i++) {
        dais.push(i + 1);
      }
      return dais;
    },
    adsOptions() {
      const dais = [];
      for (let i = 0; i < 101; i++) {
        dais.push(i + 1);
      }
      return dais;
    },
  },
};
</script>

<style>
.vs__selected {
  color: gray;
}
.vs__selected-options {
  color: gray !important;
}
.vs__dropdown-toggle {
  border: none;
  background-color: rgba(0, 0, 0, 0);
}
.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>

